"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ProgressBar.css");

var _Tracker = require("../../util/Tracker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This component will show a progress indicator for a given value / total possible value. */
var ProgressBar = function ProgressBar(props) {
  var cn = "ProgressBar";

  if (props.className) {
    cn += ' ' + props.className;
  }

  var color = props.color ? props.color : _atoms.Color.Trace;
  var background = props.background ? props.background : _atoms.Color.Black;
  var total = props.total ? props.total : 100;
  var value = props.value ? props.value : 0;
  var borderRadius = props.borderRadius ? props.borderRadius : '';
  var width = props.width ? props.width : '100%';
  var height = props.height ? props.height : 8;
  var opacity = props.opacity ? props.opacity : 1;
  var percent = value / total * 100;
  var styles = {
    width: width,
    height: height,
    borderRadius: borderRadius
  };
  var stylesBackground = {
    background: "var(--".concat(background, ")"),
    width: '100%',
    borderRadius: borderRadius,
    opacity: opacity
  };
  var stylesProgress = {
    background: "var(--".concat(color, ")"),
    width: "".concat(percent, "%"),
    maxWidth: '100%',
    borderRadius: borderRadius
  };

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    color: null,
    background: null,
    total: null,
    value: null,
    borderRadius: null,
    className: cn
  });

  var sendEvent = function sendEvent() {
    (0, _Tracker.trackEvent)({
      context: 'ProgressBar',
      action: 'Progress Bar Clicked'
    });
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    style: styles,
    onClick: function onClick() {
      return sendEvent();
    }
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "progress-bar-elements",
    style: stylesBackground
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "progress-bar-elements",
    style: stylesProgress
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.propTypes = {
  color: _propTypes.default.oneOf(Object.keys(_atoms.Color).map(function (k) {
    return _atoms.Color[k];
  })),
  background: _propTypes.default.oneOf(Object.keys(_atoms.Color).map(function (k) {
    return _atoms.Color[k];
  })),
  total: _propTypes.default.number,
  value: _propTypes.default.number,
  borderRadius: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.number,
  opacity: _propTypes.default.number
};